import { render } from "./AuctionCard.vue?vue&type=template&id=a0124478"
import script from "./AuctionCard.vue?vue&type=script&lang=js"
export * from "./AuctionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__